import { ApolloClient, HttpLink, InMemoryCache } from "apollo-boost";

//remove this to .env file

const httpLink = new HttpLink({
  uri: "https://graphql.datocms.com/",
  headers: {
    Authorization: "Bearer ed688541dcd89df82ea5ca99d0bef0",
  },
});
export const client = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
});
